import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class VariantTableHeaderCell extends Vue {

    @Prop() private props!: any;

    private showTooltip = false;

    onTooltipInput(value: boolean) {
        const realWidth = this.$el.clientWidth;
        const fullWidth = this.$el.scrollWidth;

        if(realWidth === undefined || fullWidth === undefined)
            return;

        if(fullWidth - 1 > realWidth)
            this.showTooltip = value;
        else this.showTooltip = false;
    }
}